import { Category } from 'src/types/helios/Category';
import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const CategoryFormValidator = (category?: Category | null): FormValidator => {
  const validator = new FormValidator();

  validator
    .addRule(
      'categoryName',
      ValidationRules.required,
      'Error: Please enter a category name.',
    )
    .addRule(
      'businessUnitId',
      ValidationRules.required,
      'Error: Please select the BusinessUnit.',
    )
    .addRule('divisionName', ValidationRules.required, 'Error: Please select a division.')
    // Description is now optional - no validation needed
    .addRule(
      'requiredTags',
      (value: string[]) => value && value.length > 0,
      'Error: Please select at least one Tag Group.',
    );

  return validator;
};
